import React, { Component } from 'react'
import { combineNames, /*FieldCol, FamilyReferralStatusOptions*/ } from '../FamilyReferrals/FamilyReferralHelpers.jsx'
import TabsIntake from './TabsIntake'
import Modal from '../../components/Modal/Modal'
import YSpinner from '../../elements/Spinner/Spinner'
import { GetIntakeNamesEPmbo } from '../../variables/Config'
import { DigmaEntity}  from '../../variables/DigmaDef'
import { teamMembers, familyIntakeStatus } from '../../variables/ComboValues'

// Generate grid list / index of all referral names
class Intakei extends Component {
    constructor(props) {
        super(props);
        this.state = { showme: false, isLoading: true }
    }
    handleShow = (ev, mykey) => {
        ev.preventDefault()
        this.props.curFamily(mykey) // tell parent which is current family
        this.setState({ showme: true })
    }
    handleHide = (ev) => {
        ev.preventDefault()
        this.setState({ showme: false })
    }

    render() {
        const { intakeInfo, mykey, mbouser, active, cptId, updateIlist } = this.props;

        if (this.state.showme)
            return (
                <Modal root={document.getElementById('modal-root')}>
                    <button className="close-modal-button" onClick={this.handleHide}>סגור חלון אינטייק</button>

                    <div id={'r-' + mykey} className="family-form-display modal family-form-inner height2850">
                        <TabsIntake cptId={cptId} mbouser = {mbouser} updateIlist = {updateIlist} />
                    </div>
                </Modal>
            )
        else {
            if (intakeInfo === undefined) {
                console.log("Intakei ERROR - referral undfefined= mykey=", mykey)
                return (<div key={mykey} id={"referral-"+mykey} className="referral-i" onClick={() => alert('תקלת מערכת - לא ניתן להציג מוטב לא מוגדר')}>לא מוגדר</div>)
            }
            
            let fclass = active === mykey ? "referral-i active" : "referral-i"
          
            let family = intakeInfo['f']
            let woman = intakeInfo['w']
            let man = intakeInfo['m']
            let status = intakeInfo['s']
           
            return (<div key={mykey} id={"referral-"+mykey} className={fclass} 
                        onClick={(event) => this.handleShow(event, mykey)}>
                        {combineNames(family, woman, man, status)}
                    </div>)
        }
    }
}

// main referral index component
// gets the data & use components to display it
class FamilyIntakeBody extends Component {
    constructor(props) {
        super(props)
        this._isMounted = false
        const { mbouser } = this.props
        this.state = {
            referrals: [], 
            intakesList: [],
            restError: "",
            filter: "", filterbystatus: "", 
            filterbymember: teamMembers.includes(mbouser.user_display_name) ? mbouser.user_display_name : "", 
            showModal: false,
            //modalRoot: document.getElementById('modal-root'),
            isLoading: true
        }
        this.currentFamily = this.currentFamily.bind(this)
        this.updateIntakeList = this.updateIntakeList.bind(this)
    }
    // called by child to enable bg color on last visted family
    currentFamily = (x) => {
        this.setState({active: x})
    }
    updateIntakeList = (newIntakeStatus) => {
        // update list if status or team member changed
        //console.log('newIntakeStatus ', newIntakeStatus)
        //console.log('intakesList= ', this.state.intakesList)
        let newrlist = [...this.state.intakesList]
        for (let i = 0; i < newrlist.length; i++){
            if (newrlist[i]['id'] === parseInt(newIntakeStatus['intake_code'])){
                if (newrlist[i]['s'] !==  newIntakeStatus['intake_status'] || newrlist[i]['t'] !==  newIntakeStatus['intake_yahav_member']){
                    newrlist[i]['s'] =  newIntakeStatus['intake_status']
                    newrlist[i]['t'] =  newIntakeStatus['intake_yahav_member']
                    this.setState({ intakesList: newrlist })
                    break
                }
            }
        }
    }
    
    fetchIntakesList = (url) => {
        //let newurl = 'https://www.digma.tech/wp-json/wp/v2/digma_referrals?per_page=100&fields=id,acf&page=1'
        fetch( url ,{headers: {'Accept-Encoding' : 'gzip'}} )
        //fetch(url + pagen /*,{headers: {'Access-Control-Allow-Origin':'*', mode: 'no-cors'}}*/)
            .then(response => {
                if (response.ok) {
                    if (!this._isMounted) return null
                    return response.json()
                }
                throw new Error('fetchIntakesList: Something went wrong ...')
            })
            .then(intakesList => {
                // TODO: perform cleanup of invalid posts (e.g. no family name.. or other vital data)
                intakesList.sort(function (a, b) {
                    if (a['f'] > b['f'])
                        return 1
                    if (a['f'] < b['f'])
                        return -1
                    return 0
                })
                if (!this._isMounted) return null
                this.setState({ intakesList, isLoading: false })
                return true; // void - no one is looking...
            })
            .catch(restError => this.setState({ restError: restError, isLoading: false }))
    }
    /* use list instaed
    //url is the rest api query until 'page=' included
    fetchIntakes = (url, pagen, allReferrals) => {
        let totalPages = -1 // it is fixed during the loop & reread
        let newurl = url + pagen
        //let newurl = 'https://www.digma.tech/wp-json/wp/v2/digma_referrals?per_page=100&fields=id,acf&page=1'
        fetch( newurl ,{headers: {'Accept-Encoding' : 'gzip'}} )
        //fetch(url + pagen /*,{headers: {'Access-Control-Allow-Origin':'*', mode: 'no-cors'}}* /)
            .then(response => {
                if (response.ok) {
                    totalPages = response.headers.get('X-WP-TotalPages')
                    // console.log("Total pages", totalPages)
                    if (!this._isMounted) return null
                    return response.json()
                } else
                    throw new Error('Something went wrong ... page=' + pagen)
            })
            .then(referrals => {
                if (!this._isMounted) return null
                // TODO: perform cleanup of invalid posts (e.g. no family name.. or other vital data)
                allReferrals = [...allReferrals, ...referrals]
                if (totalPages > pagen) {
                    allReferrals.sort(function (a, b) {
                        if (a['acf']['family_referral_family_name'] > b['acf']['family_referral_family_name'])
                            return 1
                        if (a['acf']['family_referral_family_name'] < b['acf']['family_referral_family_name'])
                            return -1
                        return 0
                    })
                    if (!this._isMounted) return null
                    return this.fetchIntakes(url, pagen + 1, allReferrals)
                } else {
                    //console.log("allreferrals", allReferrals)
                    allReferrals.sort(function (a, b) {
                        if (a['acf']['family_referral_family_name'] > b['acf']['family_referral_family_name'])
                            return 1
                        if (a['acf']['family_referral_family_name'] < b['acf']['family_referral_family_name'])
                            return -1
                        return 0
                    })
                    if (!this._isMounted) return null
                    this.setState({ referrals: allReferrals, isLoading: false })
                    return true; // void - no one is looking...
                }
            })
            .catch(restError => this.setState({ restError: restError, isLoading: false }))
    }*/
    componentDidMount() {
        this._isMounted =true

       /* this.setState({
            modalRoot: document.getElementById('modal-root'),
            isLoading: true
        })*/
        this.fetchIntakesList(GetIntakeNamesEPmbo)
        /* old fetch all intakes
        // var uri = "http://yahav/wp-json/wp/v2/digma_intakes"IntakesEP
        const uri = GetIntakesEP()
        const fields = "per_page=100&fields=id,acf"
        var allReferrals = []
        this.fetchIntakes(uri + "?" + fields + "&page=", 1, allReferrals)
        -  end old fetch all intakes */
    }
    componentWillUnmount(){
        this._isMounted = false
    }
    filter = (e) => {
        e.preventDefault()
        //this.setState({ filter: e.target.value, filterbystatus: "" })
        this.setState({ filter: e.target.value})
    }
    filterbymember = (e) => {
        e.preventDefault()
        this.setState({ filterbymember: e.target.value})
    }
    // if filter by status - emptyfilter by name
    filterbystatus = (e) => {
        e.preventDefault()
//        this.setState({ filterbystatus: e.target.value, filter: "" })
        this.setState({ filterbystatus: e.target.value})
    }

    render() {
        const {intakesList, isLoading, restError, filterbystatus, filterbymember, filter, active } = this.state

        // let i = 0
        if (isLoading ) // || !items.length
            return (<YSpinner />)
        if (restError !== "")
            return <h2>תקלה חולפת: {restError}</h2>
            
        // all intakes let items = Object.assign(referrals)
        let items = Object.assign(intakesList)
            
        if (filterbystatus) {
            if (filterbystatus === 'לא מוגדר')
                items = items.filter(item => {
                    return !familyIntakeStatus.includes(item['s'])})
            else 
                items = items.filter(item => {
                    return item['s'].includes(filterbystatus)})
        }
        if (filterbymember){
            if (filterbymember === 'לא מוגדר')
                items = items.filter(item => {
                    return !teamMembers.includes(item['t'])})
            else 
                items = items.filter(item => {
                    return item['t'].includes(filterbymember)}) 
        }
        if (filter) {
            items = items.filter(item => 
                item['f'].includes(filter) || item['w'].includes(filter) || item['m'].includes(filter))
        }

        return (
            <div id="main-win">
                <h3 className="table-header">אינדקס {DigmaEntity} באינטייק ({items.length})</h3>

                <div className="yahav-index-families" >                
                    <input id="filter-by-name" type="text" value={filter} 
                                    onChange={this.filter} placeholder="חיפוש לפי שם..." />
                    <span>&nbsp;&nbsp;</span>
                    <select onChange={this.filterbystatus} value={filterbystatus} >
                        <option value="" >סטטוס: כל המשפחות</option>
                        {familyIntakeStatus.map(item => <option key={item} value={item} >{item}</option>)}
                        <option value="לא מוגדר" >לא מוגדר</option>                                     
                    </select>
                    <span>&nbsp;&nbsp;</span>
                    <select onChange={this.filterbymember} value={filterbymember} >
                        <option value="" >מלווה משפחה:  כולם</option>
                        {teamMembers.map(item => <option key={item} value={item} >{item}</option>)} 
                        <option value="לא מוגדר" >לא מוגדר</option>                    
                    </select>
                    <br /><br />
                    <div className="yahav-index-intake-families-items" >
                        {items.length === 0 ? <h3>לא נמצאו משפחות, נסה/י חיפוש אחר</h3>
                            : items.map(item => {
                            return <Intakei key={item['id']} cptId={item['id']} mykey={item['id']} 
                                    intakeInfo = {item}
                                    updateIlist = {this.updateIntakeList}
                                    curFamily = {this.currentFamily}
                                    active = {active}
                                    mbouser = {this.props.mbouser} />
                        })
                        }
                    </div>
                </div>
            </div>
        )
    }
}
class FamilyIntakeIndex extends Component {
    render() {
        return (
            <div>
                <div id="modal-root"></div>
                <FamilyIntakeBody mbouser = {this.props.mbouser} />
            </div>
        )
    }
}
export default FamilyIntakeIndex


/*
    // addReferral is called for new or update referral
    addReferral = (updatedFamily, newrf) => {
        updatedFamily['family_referral_code'] = parseInt(updatedFamily['family_referral_code'])
        updatedFamily['family_referral_family_code'] = parseInt(updatedFamily['family_referral_family_code'])
        let newFobj = {
            id: updatedFamily['family_referral_code'],
            acf: updatedFamily
        }
       
        if (!newrf) { // replace update referral
            // find old
            let allReferrals = this.state.referrals
            let i =0
            // find line to replace
            while (i < allReferrals.length && allReferrals[i]['id'] !== newFobj['id']) i++
            // if not found ERROR
            if (i >= allReferrals.length){
                console.log("INTERNAL ERROR addReferral - could not find referral object", newFobj)
                return null
            }
            allReferrals.splice( i, 1, newFobj) // replace            
            this.setState({ referrals: allReferrals }) // update
            return true
        }
        // else add new
        
        let allReferrals = this.state.referrals
        allReferrals.push(newFobj)
      // sort
        allReferrals.sort(function (a,b) {
            if (a['acf']['family_referral_family_name'] > b['acf']['family_referral_family_name'])
                return 1
            if (a['acf']['family_referral_family_name'] < b['acf']['family_referral_family_name'])
                return -1
            return 0
        })
        this.setState({ referrals: allReferrals })
        return true
    }
    sortReferrals = () => {
        let allReferrals = Object.assign(this.state.referrals)
        allReferrals.sort(function (a, b) {
            if (a['acf']['family_referral_family_name'] > b['acf']['family_referral_family_name'])
                return 1
            if (a['acf']['family_referral_family_name'] < b['acf']['family_referral_family_name'])
                return -1
            return 0
        })
        this.setState({ referrals: allReferrals })
    }*/